<top-bar-filters
  [reactiveForm]="filtersForm"
  [formLayoutConfig]="filtersLayoutConfig"
  [formControlsConfigMap]="filtersConfigMap"
  [valuesMap]="valuesMap"
  [nonRemovableSectionIds]="['dateRange']"
  (updateValuesMap)="updateValuesMap($event)"
  (onApply)="applyFilters()"
  (onClear)="clearFilters()"
>
</top-bar-filters>

@if (error) {
  <hub-alert class="cat__error" alertType="danger">{{ error }}</hub-alert>
}

@if (loading) {
  <div class="loading__message d-flex align-items-center">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span class="loading__message-text ml-3">Loading real-time data, please wait…</span>
  </div>
}

@if (summary && !loading) {
  <div class="cat__charts d-flex">
    <div class="cat__chart-card">
      <div class="cat__chart-header">
        <p class="cat__chart-title">Tickets by Type <span class="cat__chart-top5">(Top 5)</span></p>
        <div class="cat__chart-header-right">
          @if (chartFiltersForm.value.filterByType?.length) {
            <button class="cat__filter-chip" (click)="clearChartFilter('filterByType')">
              <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
                <path
                  d="M1.5 1.5L8.5 8.5M8.5 1.5L1.5 8.5"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
              </svg>
              <span class="cat__filter-chip-label">{{ chartFiltersForm.value.filterByType[0] }}</span>
              @if (chartFiltersForm.value.filterByType.length > 1) {
                <span class="cat__filter-chip-count">+{{ chartFiltersForm.value.filterByType.length - 1 }}</span>
              }
            </button>
          }
          <custom-dropdown-control
            controlName="filterByType"
            [reactiveForm]="chartFiltersForm"
            [controlConfig]="typeChartFilterConfig"
            (closed)="load()"
          ></custom-dropdown-control>
        </div>
      </div>
      <div class="cat__chart-body">
        @if (typeChartLegend.length) {
          <div class="cat__chart-wrapper">
            <canvas
              baseChart
              [type]="'doughnut'"
              [data]="typeChartData"
              [options]="doughnutOptions"
              [plugins]="chartPlugins"
            ></canvas>
          </div>
          <div class="cat__chart-legend">
            @for (item of typeChartLegend; track item.label) {
              <div class="cat__legend-item">
                <span class="cat__legend-dot" [style.background]="item.color"></span>
                <div class="cat__legend-text-group">
                  <span class="cat__legend-name">{{ item.label }}</span>
                  <span class="cat__legend-count">({{ item.count.toLocaleString() }})</span>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="cat__chart-empty">
            <mat-icon class="cat__chart-empty-icon">donut_large</mat-icon>
            <span class="cat__chart-empty-text">No data available for the selected filters.</span>
          </div>
        }
      </div>
    </div>
    <div class="cat__chart-card">
      <div class="cat__chart-header">
        <p class="cat__chart-title">Tickets by Sub-Type <span class="cat__chart-top5">(Top 5)</span></p>
        <div class="cat__chart-header-right">
          @if (chartFiltersForm.value.filterBySubType?.length) {
            <button class="cat__filter-chip" (click)="clearChartFilter('filterBySubType')">
              <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
                <path
                  d="M1.5 1.5L8.5 8.5M8.5 1.5L1.5 8.5"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
              </svg>
              <span class="cat__filter-chip-label">{{ chartFiltersForm.value.filterBySubType[0] }}</span>
              @if (chartFiltersForm.value.filterBySubType.length > 1) {
                <span class="cat__filter-chip-count">+{{ chartFiltersForm.value.filterBySubType.length - 1 }}</span>
              }
            </button>
          }
          <custom-dropdown-control
            controlName="filterBySubType"
            [reactiveForm]="chartFiltersForm"
            [controlConfig]="subTypeChartFilterConfig"
            (closed)="load()"
          ></custom-dropdown-control>
        </div>
      </div>
      <div class="cat__chart-body">
        @if (subTypeChartLegend.length) {
          <div class="cat__chart-wrapper">
            <canvas
              baseChart
              [type]="'doughnut'"
              [data]="subTypeChartData"
              [options]="doughnutOptions"
              [plugins]="chartPlugins"
            ></canvas>
          </div>
          <div class="cat__chart-legend">
            @for (item of subTypeChartLegend; track item.label) {
              <div class="cat__legend-item">
                <span class="cat__legend-dot" [style.background]="item.color"></span>
                <div class="cat__legend-text-group">
                  <span class="cat__legend-name">{{ item.label }}</span>
                  <span class="cat__legend-count">({{ item.count.toLocaleString() }})</span>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="cat__chart-empty">
            <mat-icon class="cat__chart-empty-icon">donut_large</mat-icon>
            <span class="cat__chart-empty-text">No data available for the selected filters.</span>
          </div>
        }
      </div>
    </div>
    <div class="cat__chart-card">
      <div class="cat__chart-header">
        <p class="cat__chart-title">Tickets by Item <span class="cat__chart-top5">(Top 5)</span></p>
        <div class="cat__chart-header-right">
          @if (chartFiltersForm.value.filterByItem?.length) {
            <button class="cat__filter-chip" (click)="clearChartFilter('filterByItem')">
              <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
                <path
                  d="M1.5 1.5L8.5 8.5M8.5 1.5L1.5 8.5"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
              </svg>
              <span class="cat__filter-chip-label">{{ chartFiltersForm.value.filterByItem[0] }}</span>
              @if (chartFiltersForm.value.filterByItem.length > 1) {
                <span class="cat__filter-chip-count">+{{ chartFiltersForm.value.filterByItem.length - 1 }}</span>
              }
            </button>
          }
          <custom-dropdown-control
            controlName="filterByItem"
            [reactiveForm]="chartFiltersForm"
            [controlConfig]="itemChartFilterConfig"
            (closed)="load()"
          ></custom-dropdown-control>
        </div>
      </div>
      <div class="cat__chart-body">
        @if (itemChartLegend.length) {
          <div class="cat__chart-wrapper">
            <canvas
              baseChart
              [type]="'doughnut'"
              [data]="itemChartData"
              [options]="doughnutOptions"
              [plugins]="chartPlugins"
            ></canvas>
          </div>
          <div class="cat__chart-legend">
            @for (item of itemChartLegend; track item.label) {
              <div class="cat__legend-item">
                <span class="cat__legend-dot" [style.background]="item.color"></span>
                <div class="cat__legend-text-group">
                  <span class="cat__legend-name">{{ item.label }}</span>
                  <span class="cat__legend-count">({{ item.count.toLocaleString() }})</span>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="cat__chart-empty">
            <mat-icon class="cat__chart-empty-icon">donut_large</mat-icon>
            <span class="cat__chart-empty-text">No data available for the selected filters.</span>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (loadingTickets && !loading) {
  <div class="cat__loading d-flex justify-content-center align-items-center" style="min-height: 100px">
    <mat-spinner [diameter]="28"></mat-spinner>
  </div>
}

@if (ticketPageData && !loading && !loadingTickets && noTicketData) {
  <div class="cat__table-empty">
    <mat-icon class="cat__table-empty-icon">search_off</mat-icon>
    <p class="cat__table-empty-title">No data available for the selected filters.</p>
    <p class="cat__table-empty-subtitle">Try adjusting or clearing the filters to see results.</p>
  </div>
}

@if (ticketPageData && !loading && !loadingTickets && !noTicketData) {
  <div class="cat__table">
    <div class="cat__table-scroll">
      <table
        mat-table
        [dataSource]="ticketPageData.data"
        class="udt-table w-100"
        matSort
        matSortDisableClear
        [matSortActive]="sortBy"
        [matSortDirection]="sortDir"
        (matSortChange)="onSortChange($event)"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Ticket #</th>
          <td mat-cell *matCellDef="let row">
            <a class="cat__ticket-link" [routerLink]="['/secured/managed-services/tickets', row.id]">{{ row.id }}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="dateEntered">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Entered</th>
          <td mat-cell *matCellDef="let row">{{ row.dateEntered | hubDate }}</td>
        </ng-container>
        <ng-container matColumnDef="closedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Closed</th>
          <td mat-cell *matCellDef="let row">{{ row.closedDate ? (row.closedDate | hubDate) : '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="contact">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact</th>
          <td mat-cell *matCellDef="let row">{{ row.contactName ?? '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let row">{{ row.status }}</td>
        </ng-container>
        <ng-container matColumnDef="summary">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Summary</th>
          <td mat-cell *matCellDef="let row" class="cat__summary-cell">{{ row.summary }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <mat-paginator
      [length]="ticketPageData.total"
      [pageSize]="pageSize"
      [pageIndex]="currentPage - 1"
      [pageSizeOptions]="[25, 50, 100, 200]"
      showFirstLastButtons
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
}
